<template>
  <div class="ct-newsletter">
    <!-- <div class="container">
      <div
        class="ct-newsletter-wrapper"
        :style="{
          background: `url(${componentAttrs.bg_pattern}), ${$root.color_schema.primary}`,
        }"
      >
        <div class="ct-newsletter-image">
          <svg viewBox="0 0 45 48">
            <path
              d="M45 17.4541H0L20.7102 36.1921C21.733 37.2188 23.267 37.2188 24.2898 36.1921L45 17.4541Z"
              fill="#E4A644"
            />
            <path
              d="M45 17.4549H0L20.9659 0.770411C21.9886 0.000357732 23.5227 0.000357732 24.2898 0.770411L45 17.4549Z"
              fill="#E09F3A"
            />
            <path
              d="M24.2898 3.59394L41.4205 17.1982H45.2557L24.2898 0.770411C23.267 0.000357732 21.733 0.000357732 20.9659 0.770411L0 17.4549H3.83523L20.9659 3.85062C21.733 2.82389 23.267 2.82389 24.2898 3.59394Z"
              fill="#F3BD5E"
            />
            <path d="M42.4433 0H2.55688V40.5561H42.4433V0Z" fill="#F0F0F0" />
            <path
              opacity="0.5"
              d="M42.6989 0H2.55688V40.2995L42.6989 0.256684V0Z"
              fill="white"
            />
            <path
              d="M0 17.4541V47.9996L22.5 32.8552L0 17.4541Z"
              fill="#FFD273"
            />
            <path
              d="M22.5002 32.8552L45.0002 47.9996V17.4541L22.5002 32.8552Z"
              fill="#FFCB69"
            />
            <path
              opacity="0.5"
              d="M0 17.4541L22.5 32.5985L23.267 32.0851L0 17.4541Z"
              fill="#C6B5B2"
            />
            <path
              opacity="0.5"
              d="M21.9888 32.0851L22.7558 32.5985L45.0001 17.4541L21.9888 32.0851Z"
              fill="#C6B5B2"
            />
            <path
              d="M0 48.0001H45L23.267 30.2888C22.7557 29.7755 21.9886 29.7755 21.4773 30.2888L0 48.0001Z"
              fill="#F3BD5E"
            />
            <path
              opacity="0.4"
              d="M0 47.9998V46.4597L16.6193 34.3955L0 47.9998Z"
              fill="#CA9B2C"
            />
            <path
              opacity="0.4"
              d="M44.9999 47.9998V46.4597L28.6362 34.3955L44.9999 47.9998Z"
              fill="#CA9B2C"
            />
          </svg>
        </div>
        <div class="ct-newsletter-content" v-if="!submitted">
          <h2 class="custom-font-1">
            {{ $root.i18n.sign_up_to_receive_updates }}
          </h2>

          <form
            class="ct-newsletter-form"
            @submit.prevent="submit"
            :style="{ '--primary-btn': $root.color_schema.primary_btn }"
            novalidate
          >
            <div class="form-inner-wrapper">
              <div class="email-error" v-if="!validation.email">
                {{ $root.i18n.this_must_be_a_valid_email_address }}
                <span class="arrow-down"></span>
              </div>
              <label
                :class="{
                  'email-wrapper': true,
                  'email-error-wrapper': !validation.email,
                }"
                @focus="validation.email = true"
              >
                <svg viewBox="0 0 16 12">
                  <path
                    d="M8.45626 8.04793C8.30525 8.14393 8.13537 8.18233 7.98437 8.18233C7.83336 8.18233 7.66348 8.14393 7.51248 8.04793L0 3.38232V9.58393C0 10.9087 1.05703 11.9839 2.35945 11.9839H13.6282C14.9306 11.9839 15.9876 10.9087 15.9876 9.58393V3.38232L8.45626 8.04793Z"
                  />
                  <path
                    d="M13.6283 0.00341797H2.35963C1.24597 0.00341797 0.302191 0.809818 0.0756836 1.88502L8.00343 6.80022L15.9123 1.88502C15.6858 0.809818 14.742 0.00341797 13.6283 0.00341797Z"
                  />
                </svg>
                <input
                  type="email"
                  ref="email"
                  name="email"
                  :class="{ 'email-error-input': !validation.email }"
                  :placeholder="$root.i18n.your_email"
                  v-model="email"
                />
              </label>
              <label
                :class="{
                  'checkbox-label': !checkbox.checkbox1,
                  'checkbox-label-error':
                    !checkbox.checkbox1 && !validation.checkbox1,
                  'checkbox-label-selected': checkbox.checkbox1,
                }"
              >
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="checkbox.checkbox1"
                />
                {{ $root.i18n.yes_i_would_like_to_receive_the_latest_news }}
              </label>
              <div
                class="checkbox-error"
                v-if="!validation.checkbox1 && !checkbox.checkbox1"
              >
                {{ $root.i18n.you_must_check_this_box_to_register }}
                <span class="arrow-up"></span>
              </div>
              <label
                :class="{
                  'checkbox-label': !checkbox.checkbox2,
                  'checkbox-label-error':
                    !checkbox.checkbox2 && !validation.checkbox2,
                  'checkbox-label-selected': checkbox.checkbox2,
                }"
              >
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="checkbox.checkbox2"
                />
                {{ $root.i18n.yes_i_am_over_18_years_old }}
              </label>
              <div
                class="checkbox-error"
                v-if="!validation.checkbox2 && !checkbox.checkbox2"
              >
                {{ $root.i18n.you_must_check_this_box_to_register }}
                <span class="arrow-up"></span>
              </div>
            </div>
            <button
              type="submit"
              name="submit"
              v-if="!submission"
              class="
                cta cta-primary cta-block cta-promotion cta-gray
                custom-btn-sec
              "
              :style="{ '--primary-btn': $root.color_schema.primary_btn }"
            >
              {{ $root.i18n.send }}
            </button>
            <div class="submission-spinner" v-if="submission">
              <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
              >
                <path
                  d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                  transform="rotate(127.435 25 25)"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.6s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </div>
          </form>
        </div>
        <div class="ct-newsletter-content" v-if="submitted">
          <h2 class="custom-font-1">{{ $root.i18n.thank_you }}</h2>
          <p class="custom-font-2">
            {{ $root.i18n.you_are_signed_up_to_our_newsletter }}
          </p>
        </div>
      </div>
    </div> -->
  <!--Newsletter-->
    <input type="checkbox" name="sticky-newsletter-checkbox" class="sticky-newsletter-checkbox" id="sticky-newsletter-checkbox" hidden="">
    <div class="sticky-newsletter__overlay"></div>
    <div id="sticky-newsletter" class="sticky-newsletter">
      <label for="sticky-newsletter-checkbox"
        class="sticky-newsletter__button"><svg width="20" height="16" viewBox="0 0 20 16" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.258 8.119L20 13.078V2.95l-6.742 5.17zM0 2.95v10.128l6.742-4.96L0 2.95zM18.75 0H1.25C.625 0 .133.54.04 1.236L10 8.873l9.96-7.637C19.868.541 19.376 0 18.75 0zm-6.637 9l-1.77 1.354a.55.55 0 01-.343.119.578.578 0 01-.344-.119l-1.77-1.359L.04 14.773C.137 15.463.63 16 1.25 16h17.5c.621 0 1.113-.536 1.21-1.227L12.114 9z"
            fill="#fff"></path>
        </svg> <span class="sticky-newsletter__button-text">Newsletter</span>
      </label>
        <form 
          :class="{
            'sticky-newsletter__sign-up': true,
            'is-submitted': submitted
          }"
          @submit.prevent="submit"
          :style="{ '--primary-btn': $root.color_schema.primary_btn, background: `${$root.color_schema.primary}`}"
          novalidate
        >
        <label for="sticky-newsletter-checkbox"
            class="sticky-newsletter__close">X</label> <span class="sticky-newsletter__title" v-if="!submitted">{{ $root.i18n.sign_up_to_receive_updates }}</span>
          <div class="sticky-newsletter__form" v-if="!submitted">
            <div class="email-chk-outer" style="position:relative;">
              <div class="email-error" v-if="!validation.email">
                  {{ $root.i18n.this_must_be_a_valid_email_address }}
                  <span class="arrow-down"></span>
              </div>
              <label
                :class="{
                  'email-wrapper': true,
                  'email-error-wrapper': !validation.email,
                }"
                @focus="validation.email = true"
              >
                <svg width="20" height="16" viewBox="0 0 16 12">
                  <path
                    d="M8.45626 8.04793C8.30525 8.14393 8.13537 8.18233 7.98437 8.18233C7.83336 8.18233 7.66348 8.14393 7.51248 8.04793L0 3.38232V9.58393C0 10.9087 1.05703 11.9839 2.35945 11.9839H13.6282C14.9306 11.9839 15.9876 10.9087 15.9876 9.58393V3.38232L8.45626 8.04793Z"
                  />
                  <path
                    d="M13.6283 0.00341797H2.35963C1.24597 0.00341797 0.302191 0.809818 0.0756836 1.88502L8.00343 6.80022L15.9123 1.88502C15.6858 0.809818 14.742 0.00341797 13.6283 0.00341797Z"
                  />
                </svg>
                <input
                  type="email"
                  ref="email"
                  name="email"
                  :class="{ 'email-error-input': !validation.email }"
                  :placeholder="$root.i18n.your_email"
                  v-model="email"
                />
              </label>
            </div>
            <!-- <input name="email" type="email" placeholder="Just leave your email..." class="email"> -->
            <div class="sticky-newsletter__checkbox">
              <div class="chk-outer" style="position:relative;">
                <label
                  :class="{
                    'checkbox-label': !checkbox.checkbox1,
                    'checkbox-label-error':
                      !checkbox.checkbox1 && !validation.checkbox1,
                    'checkbox-label-selected': checkbox.checkbox1,
                  }"
                >
                  <input
                    type="checkbox"
                    class="checkbox"
                    v-model="checkbox.checkbox1"
                  />
                  {{ $root.i18n.yes_i_would_like_to_receive_the_latest_news }}
                </label>
                <div
                  class="checkbox-error"
                  v-if="!validation.checkbox1 && !checkbox.checkbox1"
                >
                  {{ $root.i18n.you_must_check_this_box_to_register }}
                  <span class="arrow-up"></span>
                </div>
              </div>
              <div class="chk-outer" style="position:relative;">
                <label
                  :class="{
                    'checkbox-label': !checkbox.checkbox2,
                    'checkbox-label-error':
                      !checkbox.checkbox2 && !validation.checkbox2,
                    'checkbox-label-selected': checkbox.checkbox2,
                  }"
                >
                  <input
                    type="checkbox"
                    class="checkbox"
                    v-model="checkbox.checkbox2"
                  />
                  {{ $root.i18n.yes_i_am_over_18_years_old }}
                </label>
                <div
                  class="checkbox-error checkbox-error-two"
                  v-if="!validation.checkbox2 && !checkbox.checkbox2"
                >
                  {{ $root.i18n.you_must_check_this_box_to_register }}
                  <span class="arrow-up"></span>
                </div>
              </div>
              <!-- <input type="checkbox" name="confirm_age" value="confirm_age" required="required"> 
              <label for="confirm_age">I confirm I am over the age of 18 years old.</label> -->
            </div>
            <button
              type="submit"
              name="submit"
              v-if="!submission"
              class="submit cta cta-primary cta-block cta-promotion cta-gray custom-btn-sec text-white"
              :style="{ '--primary-btn': $root.color_schema.primary_btn }"
            >
              {{ $root.i18n.send }}
            </button>
            <div class="submission-spinner" v-if="submission">
              <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="40px"
                height="40px"
                viewBox="0 0 50 50"
                style="enable-background: new 0 0 50 50"
                xml:space="preserve"
              >
                <path
                  d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                  transform="rotate(127.435 25 25)"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.6s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </div>
            <!-- <input type="submit" value="Sign me up" class="submit"> -->
          </div>
          <div class="ct-newsletter-content" v-else>
            <h2 class="custom-font-1">{{ $root.i18n.thank_you }}</h2>
            <p class="custom-font-2" style="margin-bottom: 0;">
              {{ $root.i18n.you_are_signed_up_to_our_newsletter }}
            </p>
          </div>
        </form>
    </div>
    <!--Newsletter-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Newsletter",
  props: ["componentData", "componentAttrs"],
  data: function () {
    return {
      email: null,
      validation: {
        email: true,
        checkbox1: true,
        checkbox2: true,
      },
      checkbox: {
        checkbox1: false,
        checkbox2: false,
      },
      submission: false,
      submitted: false,
    };
  },
  methods: {
    submit: function () {
      this.submission = true;

      if (!this.checkbox.checkbox1) {
        this.validation.checkbox1 = false;
        this.submission = false;
      }
      if (!this.checkbox.checkbox2) {
        this.validation.checkbox2 = false;
        this.submission = false;
      }
      const emailExp =
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      const regex = new RegExp(emailExp);

      if (!this.email || !this.email.match(regex)) {
        this.validation.email = false;
        this.$refs.email.focus();
        this.submission = false;
      }

      if (
        this.validation.checkbox1 &&
        this.validation.checkbox2 &&
        this.validation.email
      ) {
        let session_url = `/wp-json/wpvue/v1/newsletter`;
        let body = {
          EmailAddress: this.email,
        };
        axios.post(session_url, body, {
        headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
        }).then(() => {
          this.submitted = true;
          this.submission = false;
        }).catch((error) => {
          console.log('Error Submitting',error);
        });

        //setTimeout(() => {
        //this.$refs.formNews.submit();
        // let body = {
        //   email: this.email,
        // };
        // axios.post(
        //   `https://api.aweber.com/1.0/accounts/${this.$root.aweber.account_id}/lists/${this.$root.aweber.listname}/subscribers?ws.op=create`,
        //   body,
        //   {
        //     headers: {
        //       Accept: "application/json",
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${this.$root.aweber.token.access_token}`,
        //     },
        //   }
        // ).subscribe((res) => {
        //   if (res.status === 201) {
        //     this.submitted = true;
        //     this.submission = false;
        //   }
        // });
        //}, 1000);
      }
    },
  },
  mounted() {
    this.redirect = this.$root.site_url + "/" + this.$route.params.postSlug;
    this.listname = this.$root.listname;
  },
  watch: {
    email: function () {
      this.validation.email = true;
    },
    "checkbox.checkbox1": function () {
      this.validation.checkbox1 = this.checkbox.checkbox1;
    },
    "checkbox.checkbox2": function () {
      this.validation.checkbox2 = this.checkbox.checkbox2;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";
.sticky-newsletter {
  position: fixed;
  right: 0;
  bottom: 50%;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  z-index: 11;
  @media (max-width: 1024px) {
    left: 0;
  }
}
.sticky-newsletter__button {
  background-color: var(--primary-btn);
  color: #fff;
  right: 0;
  position: absolute;
  border-radius: 5px 0 0 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  grid-gap: 10px;
  gap: 10px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: 50%;
  padding: 10px;
  cursor: pointer;
}
@media (min-width: 1024px) {
  .sticky-newsletter__button {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
    right: -47px;
    border-radius: 5px 5px 0 0;
    bottom: 50%;
    margin-bottom: -22px;
    padding: 10px 15px;
  }
}

.sticky-newsletter-checkbox:checked~.sticky-newsletter .sticky-newsletter__button {
  bottom: 50%;
  margin-bottom: -22px;
  right: unset;
  left: 450px;
  -webkit-animation: buttonSlideIn .25s forwards;
  animation: buttonSlideIn .25s forwards;
}
.sticky-newsletter__sign-up {
  //background-color: #002fe9;
  padding: 25px 15px;
  width: 100%;
  border-radius: 5px;
  position: relative;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
  display: none;
  position: relative;
  z-index: 1;
  &:after{
    position: absolute;
    content:"";
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.25);
    z-index: -2;
  }

  &.is-submitted {
    padding-top: 50px;
  }
}
@media (min-width: 1024px) {
.sticky-newsletter__sign-up {
  width: 520px;
  padding: 25px 40px;
}
}
.sticky-newsletter-checkbox:checked~.sticky-newsletter .sticky-newsletter__sign-up {
  -webkit-animation: boxSlideIn .25s forwards;
  animation: boxSlideIn .25s forwards;
  display: block;
}
.sticky-newsletter__close {
  position: absolute;
  right: 20px;
  top: 10px;
  color: #fff;
  cursor: pointer;
}
.sticky-newsletter__title {
  color: #fff;
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 15px;
  display: block;
  font-weight: 700;
}
.sticky-newsletter__text {
  font-size: 16px;
  color: #fff;
}
.sticky-newsletter__form {
  padding: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-radius: 5px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
@media (min-width: 1024px) {
.sticky-newsletter__form {
  background-color: #fff;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-bottom: 20px;
}
}
.sticky-newsletter__form input {
  border: transparent;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
}
@media (min-width: 1024px) {
.sticky-newsletter__form input {
  padding: 0;
}
.sticky-newsletter__form .email {
  width: 300px;
}
}
.sticky-newsletter__checkbox {
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  grid-gap: 10px;
  gap: 10px;
  margin: 15px 0;
  font-size: 12px;
}
@media (min-width: 1024px) {
.sticky-newsletter__checkbox {
  position: absolute;
  bottom: 0;
}
}
.sticky-newsletter__form input {
  border: transparent;
  padding: 20px;
  border-radius: 5px;
}
@media (min-width: 1024px) {
.sticky-newsletter__form input {
  padding: 0;
}
}
.sticky-newsletter__checkbox label {
  margin: 0;
}
.sticky-newsletter__form .submit {
  cursor: pointer;
  padding: 10px 15px;
  border: 0;
  border-radius: 5px;
  font-weight: bold;
  background-color: #ffd03a;
}
.sticky-newsletter__overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  display: none;
  z-index: 1;
  top: 0;
  left: 0;
}
.sticky-newsletter-checkbox:checked~.sticky-newsletter__overlay {
  display: block;
}

@-webkit-keyframes buttonSlideIn {
  100% {
      left: -86px
  }
}

@keyframes buttonSlideIn {
  100% {
      left: -86px
  }
}

@-webkit-keyframes boxSlideIn {
  100% {
      -webkit-transform: translateX(0%);
      transform: translateX(0%)
  }
}

@keyframes boxSlideIn {
  100% {
      -webkit-transform: translateX(0%);
      transform: translateX(0%)
  }
}

@-webkit-keyframes boxSlideOut {
  100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%)
  }
}

@keyframes boxSlideOut {
  100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%)
  }
}
.sticky-newsletter__sign-up {
  padding-bottom: 60px;
}
.sticky-newsletter__form {
  .email-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    background: #fff;
    padding: 0 10px;
    flex-grow: 1;
    @media (min-width: 1024px) {
      background: transparent;
      padding: 0;
    }
  }
}
.sticky-newsletter__form .submit {
  margin: 0;
  min-height: 38px;
  max-width: 100%;
  text-align: center;
  font-size: 16px;
  @media (min-width: 1024px) {
    max-width: 120px;
  }
}
.sticky-newsletter__form input {
  margin-left: 10px;
}
.sticky-newsletter__checkbox {
  flex-direction: column;
  align-items: flex-start;
  grid-gap: 0;
  gap: 0;
}
.sticky-newsletter__button-text{
  display: none;
  @media (min-width: 1024px) {
    display: inline-block;
    
  }
}
.sticky-newsletter__form .email-error {
  position: absolute;
  top: -58px;
  left: 38px;
  width: auto;
  white-space: nowrap;
}
.sticky-newsletter__checkbox .checkbox-error {
  position: absolute;
  top: 24px;
  z-index: 1;
}
.sticky-newsletter__checkbox .checkbox-error-two {
  position: absolute;
  top: 30px;
  z-index: 1;
}
.email-chk-outer {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
//Old css
.ct-newsletter {
  padding: 0;
  margin: 0;
  position: absolute;
  z-index: 1001;

  &-wrapper {
    .border-radius(12px);
    color: @white;
    padding: 50px 5px 38px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background-size: cover;
  }
  &-image {
    text-align: center;
    svg {
      width: 48px;
      height: 45px;
    }
  }
  &-content {
    color: @white;
    text-align: center;
    max-width: 350px;
    margin: 0 auto;
    h2 {
      color: @white;
    }
    p {
      color: @white;
    }
  }
  &-form {
    display: flex;
    flex-direction: column;
    text-align: left;
    input {
      margin: 12px 0;
    }
    .checkbox {
      .border-radius(4px);
      border: none;
    }
    input[type="email"] {
      border: none;
      padding: 12px;
      text-indent: 26px;
      display: inline-block;
      outline: none;
      width: 100%;
    }
    .email-wrapper {
      position: relative;
      svg {
        height: 18px;
        width: 18px;
        fill: #797979;
        top: 25px;
        left: 12px;
        position: absolute;
      }
    }
    .custom-btn-sec {
      padding: 17px 18px;
      &:hover {
        background-color: var(--primary-btn) !important;
        border-color: var(--primary-btn) !important;
      }
    }
  }
}

.checkbox-label {
  position: relative;
  padding-left: 25px;
  margin-top: 10px;
  .checkbox {
    display: none;
  }
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    transition: transform 0.28s ease;
    .border-radius(2px);
    background-color: @white;
  }
  &-error {
    &::before {
      border: 2px solid var(--primary-btn);
    }
  }
  &-selected {
    position: relative;
    padding-left: 25px;
    margin-top: 10px;
    .checkbox {
      display: none;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 18px;
      height: 18px;
      transition: transform 0.28s ease;
      .border-radius(2px);
      background-color: var(--primary-btn);
    }
    &:after {
      content: "";
      display: block;
      width: 8px;
      height: 4px;
      border-bottom: 2px solid @white;
      border-left: 2px solid @white;
      transition: transform ease 0.25s;
      position: absolute;
      top: 4px;
      transform: rotate(-45deg) scale(1);
      left: 4px;
    }
  }
}

.checkbox-error {
  text-align: center;
  width: auto;
  padding: 5px;
  .border-radius(10px);
  background: var(--primary-btn);
  color: @white;
  position: relative;
  margin-bottom: 8px;
  white-space: nowrap;
}

.arrow {
  &-up {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid var(--primary-btn);
    transform: translate(-50%);
    position: absolute;
    top: -6px;
    left: 50%;
  }
  &-down {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--primary-btn);
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translate(-50%);
  }
}

.email-error {
  text-align: center;
  width: 100%;
  padding: 5px;
  .border-radius(10px);
  background: var(--primary-btn);
  color: @white;
  position: relative;
  margin-top: 8px;
  &-input {
    border: 1.4px solid var(--primary-btn) !important;
    color: var(--primary-btn);
  }
  &-wrapper {
    svg {
      fill: var(--primary-btn) !important;
    }
  }
}

.form-inner-wrapper {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.submission-spinner {
  text-align: center;
  max-height: 38px;
  svg {
    fill: var(--primary-btn);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom-block/Newsletter.vue